/* Variant → media swap (by media ID, index-agnostic) */
(function () {
  // Find main gallery
  const main =
    document.querySelector('[data-product-gallery]') ||
    document.querySelector('.product_gallery');
  if (!main) return;

  // Helpers ----------------------------------------------------
  function getFlkty(el) {
    return el?._flickity ||
           el?.flickity ||
           (window.jQuery && el && (jQuery(el).data('flickity') || jQuery(el).data('flickityInstance'))) ||
           (window.Flickity && el && window.Flickity.data && window.Flickity.data(el)) ||
           null;
  }
  function getProductJSON() {
    const el = document.querySelector('script[id^="ProductJSON-"],script[id^="ProductJson-"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch { return null; }
  }
  function findVariantById(id) {
    const p = getProductJSON();
    if (!p?.variants || !id) return null;
    return p.variants.find(v => String(v.id) === String(id)) || null;
  }
  function selectByIndex(idx) {
    if (idx < 0) return false;
    const cells = Array.from(main.querySelectorAll('.gallery-cell'));
    const slide = cells[idx];
    const flkty = getFlkty(main);
    if (flkty && typeof flkty.select === 'function') {
      flkty.select(idx, false, true);
    } else {
      slide?.scrollIntoView({ block: 'nearest' });
    }
    // keep thumb nav in sync if it exists
    const productId = main.getAttribute('data-product-id');
    const nav =
      (productId && document.querySelector(`.product-${productId}-gallery-nav`)) ||
      document.querySelector('.product-gallery__thumbnails') ||
      document.querySelector('.product_gallery_nav');
    if (nav) {
      const nflk = getFlkty(nav);
      if (nflk && typeof nflk.select === 'function') nflk.select(idx, false, true);
    }
    return true;
  }
  function selectByMediaId(id) {
    if (!id) return false;

    // First, try to derive index from the thumbnails (most reliable with Turbo)
    const nav =
      document.querySelector('.product-gallery__thumbnails') ||
      document.querySelector('.product_gallery_nav') ||
      document;
    const thumbs = Array.from(nav.querySelectorAll('.product-gallery__thumbnail'));
    let idx = thumbs.findIndex(el => String(el.getAttribute('data-media-id')) === String(id));
    if (idx >= 0) return selectByIndex(idx);

    // Next, match the slide directly
    const cells = Array.from(main.querySelectorAll('.gallery-cell'));
    const slide = main.querySelector(`.gallery-cell[data-media-id="${id}"]`);
    if (slide) return selectByIndex(cells.indexOf(slide));

    // Last resort: click any element that points at the slide
    const link = document.querySelector(`[aria-controls$="-${id}"]`);
    if (link) { link.click(); return true; }

    return false;
  }

  // Resolve selected variant id in ALL the weird cases -------------
  function getCurrentVariantId() {
    // 1) hidden/select in the add-to-cart form
    const form = document.querySelector('form[action*="/cart/add"]');
    const idField = form?.querySelector('input[name="id"], select[name="id"]');
    if (idField?.value) return idField.value;

    // 2) URL ?variant=...
    const urlId = new URLSearchParams(location.search).get('variant');
    if (urlId) return urlId;

    return null;
  }

  function applyFromCurrentVariant() {
    const vid = getCurrentVariantId();
    const variant = findVariantById(vid);
    const mediaId = variant?.featured_media?.id || variant?.featured_media_id || variant?.image_id || null;
    if (mediaId) selectByMediaId(mediaId);
  }

  // Wire-up: react no matter how the theme updates -----------------
  // A) Initial load
  applyFromCurrentVariant();

  // B) Listen for theme events if they exist
  document.addEventListener('variant:change',  e => {
    const v = e.detail?.variant;
    const id = v?.featured_media?.id || v?.featured_media_id || v?.image_id;
    if (id) selectByMediaId(id);
  });
  document.addEventListener('variant:changed', e => {
    const v = e.detail?.variant;
    const id = v?.featured_media?.id || v?.featured_media_id || v?.image_id;
    if (id) selectByMediaId(id);
  });

  // C) MutationObserver: watch for hidden id field value changes
  const form = document.querySelector('form[action*="/cart/add"]') || document;
  const obs = new MutationObserver(() => applyFromCurrentVariant());
  obs.observe(form, { subtree: true, childList: true, attributes: true, characterData: true });

  // D) Also catch regular change events on option inputs and id field
  document.addEventListener('change', (e) => {
    const n = e.target?.name || '';
    if (n === 'id' || /^option[1-3]$/.test(n) || n.startsWith('options[')) {
      applyFromCurrentVariant();
    }
  }, { passive: true });
})();
